<div class="premium-services-wrapper">
  <ng-container *ngIf="!isMobile">
    <app-premium-service-card *ngFor="let service of list" (planPurchase)="onPlanPurchaseClicked($event)" [data]="service"></app-premium-service-card>
  </ng-container>
  <ng-container *ngIf="isMobile">
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let service of list">
          <app-premium-service-card [data]="service" (planPurchase)="onPlanPurchaseClicked($event)"></app-premium-service-card>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #confirmPlanRef>
  <div class="confirm-plan-wrapper">
    <div class="header">
      <div class="info-icon-wrapper">
        <img src="/assets/images/ketto-premium-services/info-icon-gold.png" alt="info icon" />
      </div>
      <div class="close-btn-wrapper">
        <app-close-btn top="10px" right="10px" [type]="isMobile ? 'sheet': 'dialog'" />
      </div>
      <div class="content">
        <div class="title">
          Activate your {{selectedPlan|titlecase}} plan?
        </div>
        <div class="sub-title">
          Get access to premium features and support.
        </div>
      </div>
    </div>
    <div class="action-wrapper">
      <button mat-button class="cancel-btn" (click)="onCancelClicked()">
        Cancel
      </button>
      <button mat-button  class="confirm-btn" (click)="activatePlan()">
        <span *ngIf="!isLoading">
          Confirm
        </span>
        <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>


<ng-template #successfulDialogRef>
  <div class="successfull-dialog-wrapper">
    <div class="close-btn-wrapper">
      <img src="/assets/images/ketto-premium-services/x-close.png" (click)="onCancelClicked()" alt="close btn" />
    </div>
    <div class="content-wrapper">
      <div class="img-wrapper">
        <img src="/assets/images/ketto-premium-services/green-tick.png" alt="green tick image" />
      </div>
      <div class="content">
        <div class="plan-name" [class]="selectedPlan">
          <span> {{selectedPlan|titlecase}} </span> plan activated
        </div>
        <div class="plan-desc">
          Ketto will soon be supporting you in your fundraising journey. In the meantime, share your fundraiser with friends and family to kickstart your campaign!
        </div>
      </div>
      <div class="whatsapp-wrapper">
        <ng-container [ngTemplateOutlet]="shareBtnWrapper" />
      </div>
    </div>
  </div>
</ng-template>



<ng-template #shareBtnWrapper>
  <div class="whatsapp-share-wrapper">
    <div class="share-btn-wrapper">
      <button mat-button class="share-btn" (click)="getWhatsAppMessage()"> 
        <mat-icon class="icon-whatsapp" [style.color]="white"></mat-icon>
        <span class="label">{{info?.whatsappShareContent?.shareTitle}}</span>
      </button>
    </div>
    <div class="desc">
      {{info?.whatsappShareContent?.desc}}
    </div>
  </div>
</ng-template>